export default class AppearingField {
    element;
    trigger;
    isVDP;
    constructor(element) {
        this.element = element;
        this.trigger = document.querySelector('.js-trigger-field select');
        this.isVDP = false;
        if (window.location.search.includes('isvdp=1')) {
            this.isVDP = true;
        }
        if (!this.trigger || this.isVDP)
            return;
        this.trigger.onchange = () => {
            if (this.trigger.value.includes('js-trigger')) {
                this.element.classList.remove('appearing-field');
            }
            else if (!this.element.classList.contains('appearing-field')) {
                this.element.classList.add('appearing-field');
            }
        };
    }
}
